

































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import collectorPo from "@/store/entities/devices/collectorpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { Common } from "@/lib/Common/Guid";
@Component({
  components: { TreeSelect },
})
export default class CreateCollector extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  collectorPo: collectorPo = new collectorPo();
  loading: boolean = false;
  created() {
    this.areaTree();
    this.getItemDetail();
    this.getmodelType();
    this.collectorPo.isEnable = 1;
    this.collectorPo.rateNum = 0;
  }
  async getmodelType() {
    await this.$store
      .dispatch("collectormodel/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.modelType.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 5;
      });
      info.forEach((ele) => {
        this.$data.potocolType.push({ label: ele.name, value: ele.id });
      });
      let ispl = detaillist.filter((p) => {
        return p.itemId == 3;
      });
      ispl.forEach((ele) => {
        this.$data.ispType.push({ label: ele.name, value: ele.id });
      });
      let device = detaillist.filter((p) => {
        return p.itemId == 4;
      });
      device.forEach((ele) => {
        this.$data.deviceType.push({ label: ele.name, value: ele.id });
      });
    }
  }
  async getmodelinfo(val: any) {
    if (val != undefined && val > 0) {
      await this.$store
        .dispatch({ type: "collectormodel/get", id: val })
        .then((ele) => {
          if (ele != null) {
            this.collectorPo = ele;
            this.collectorPo.modelId = val;
            this.collectorPo.id = Common.Guid.MakeNew().ToString();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  save() {
    (this.$refs.itemModelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        if (
          this.collectorPo.isp != 40 &&
          this.collectorPo.isp != 41 &&
          this.collectorPo.isp != 42 &&
          this.collectorPo.imei == null
        ) {
          this.$Modal.warning({
            title: this.L("Tips"),
            content: this.L("Imei") + this.L("CanNotBeEmpty"),
            okText: this.L("Yes"),
            cancelText: this.L("No"),
          });
          this.loading = false;
          return;
        }
        var checkval = await this.$store.dispatch({
          type: "collector/checkNo",
          data: this.collectorPo,
        });
        if (checkval.item1) {
          this.$Modal.warning({
            title: this.L("Tips"),
            content: checkval.item2,
            okText: this.L("Yes"),
            cancelText: this.L("No"),
          });
          this.loading = false;
          return;
        }
        await this.$store
          .dispatch({
            type: "collector/create",
            data: this.collectorPo,
          })
          .catch(() => {
            this.loading = false;
          });
        this.loading = false;
        this.collectorPo = new collectorPo();
        this.collectorPo.isEnable = 1;
        (this.$refs.itemModelForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.itemModelForm as any).resetFields();

    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  modelRule = {
    areaId: [
      {
        required: true,
        type: "number",
        message: this.L("Areas") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    no: [
      {
        required: true,
        message: this.L("Number") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    logicNo: [
      {
        required: true,
        message: this.L("Logic") + this.L("Number") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    protocol: [
      {
        required: true,
        type: "number",
        message: this.L("Protocol") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    modelId: [
      {
        required: true,
        type: "number",
        message: this.L("Device") + this.L("Model") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    isp: [
      {
        required: true,
        type: "number",
        message: this.L("ISP") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    deviceTypeId: [
      {
        required: true,
        type: "number",
        message:
          this.L("Device") + this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.arealist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  data() {
    return {
      arealist: [],
      ispType: [],
      potocolType: [],
      deviceType: [],
      modelType: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
